export enum Currency {
  ZAR = "ZAR",
  USD = "USD"
}
